<template>
	<div>
		<div id="bid-popup" v-if="showBidPopup" style = "background:#d4d4d4 ">
			<p class='info'>
				NOTE: Max Bid Should always be greater than Min Bid and in range of {{parseBid(minBidLimit) +' to '+parseBid(maxBidLimit)}}.
			</p>
			<input ref = 'id__bid' v-if="editType == 'bid'" type="number" onkeypress="return (event.charCode >= 48 || event.charCode ==46)" v-on:keydown="fixBidDecimal" :min="minBidLimit" :max="maxBidLimit" class="budget-value" v-model="tempBidVal" v-on:input = "updateBid" />
			<select class="form-control bid-status" v-else-if="editType == 'status'" v-model="selectedItem.state">
				<option value="enabled">Enabled</option>
				<option value="disabled">Disabled</option>
			</select>
			<span v-if="bidSaving" span class="spinner-border ml-4 mt-2"></span>
			<button class="btn btn-primary ml-3 mt-0 mb-0" @click="updateKeywordRow($event, selectedItem, selectedItemIndex, tempBidVal)" v-else-if = "(!isWrongBid) && (tempBidVal)">Save</button>
			<button class="btn btn-secondary" v-if="!bidSaving" @click="showBidPopup = false ; isWrongBid = false" style = "background: #d4d4d4">Cancel</button>
		</div>
		<div id="bid-popup2" v-if="showMinMaxBid" style = "background:#d4d4d4">
			<p class='info'>
				NOTE: Max Bid Should always be greater than Min Bid and in range of {{parseBid(minBidLimit) +' to '+parseBid(maxBidLimit)}}.
			</p>
			<input ref = 'id__max__min' type="number" onkeypress="return (event.charCode >= 48 || event.charCode ==46)" v-on:keydown="fixMinMaxBidDecimal"  :min="minBidLimit" :max="maxBidLimit" class="budget-value" v-model="minMaxBid" v-on:input = "updateMinMaxBid" />
			<span v-if="bidSaving" span class="spinner-border ml-4 mt-2"></span>
			<button class="btn btn-primary ml-3 mt-0 mb-0" @click="updateBidVal($event, selectedItem, selectedItemIndex)" v-else-if = "!isWrongVal">Save</button>
			<button v-if="!bidSaving" class="btn btn-secondary" @click="showMinMaxBid = false;isWrongVal = false" style = "background: #d4d4d4">Cancel</button>
			<!-- <p v-if = "isWrongVal" style = "font-size:12px;color:red;"> 
				<span>
					MaxBid Should always be greater than MinBid and in range of {{minBidLimit +' to '+maxBidLimit}}
				</span> 
			</p> -->
		</div>
		<div id="strategy-reason" v-if="showStrategy" class='reason_popover' @mouseleave="showStrategy=false">
			<p>{{strategyReason}}</p>
		</div>
	    <table class="table display mt-0" style="width: 100%;"  v-if="keywordList.length > 0">
	        <thead>
				<!-- for sd type -->
	            <tr v-if="($route.params.sponsoredType||'')=='sd'">
					<th style="width:3%;" v-if="currentPage == 'sync'" class="text-center"><input v-model="actionSelectionControl" type="checkbox"/></th>
	                <th class="link" v-on:click="sorting('status', $event)">
						{{'Status'}}
						<i
							class="sort fa"
							:class="
							sort.field == 'status'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>
					<th style="width: 10%;" class="link" v-on:click="sorting('asin', $event)">
						{{'Asin'}}
						<i
							class="sort fa"
							:class="
							sort.field == 'asin'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>
					<th style="width:170px">Product Title</th>
					<!-- <th style="width: 10%;">Tags</th> -->
					<th style="text-align:right;width:100px" class="link" v-on:click="sorting('manually_managed_bid', $event)">
						{{'Manually Managed Bid($)'}}
						<i
							class="sort fa"
							:class="
							sort.field == 'manually_managed_bid'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>
					<th style="text-align:right;width:100px" class="link" v-on:click="sorting('min_bid', $event)">
						{{'Min Bid($)'}}
						<i
							class="sort fa"
							:class="
							sort.field == 'min_bid'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>					
					<th style="text-align:right;width:100px" class="link" v-on:click="sorting('max_bid', $event)">
						{{'Max Bid($)'}}
						<i
							class="sort fa"
							:class="
							sort.field == 'max_bid'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th> 
					<th style="text-align:right;width:100px" class="link" v-on:click="sorting('current_bid', $event)">{{'Current Bid($)'}}
						<i
							class="sort fa"
							:class="
							sort.field == 'current_bid'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th> 
	                <th style="width: 7%;" class="link" v-on:click="sorting('state', $event)">Bid Status
						<i
							class="sort fa"
							:class="
							sort.field == 'state'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>
					<th style="width: 8%;" class="link" v-on:click="sorting('strategy', $event)">
						ML Strategy <span v-if="strageyLoading" span class="spinner-border" style="display: block;"></span>
						<i
							class="sort fa"
							:class="
							sort.field == 'strategy'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>
					<th style="text-align:right">Bid Change(%)</th>
					<th></th>
					<th></th>
					<th style="width:40px"></th>
	            </tr>
				<!-- for sp/sb -->
	            <tr v-else>
					<th style="width:3%;" v-if="currentPage == 'sync'" class="text-center"><input v-model="actionSelectionControl" type="checkbox"/></th>
	                <th v-if="currentPage == 'sync'" style="width: 8%;" class="link" v-on:click="sorting('status', $event)">
						Status
						<i
							class="sort fa"
							:class="
							sort.field == 'status'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i>
					</th>
					<th style="width: 8%;" class="link"	v-on:click="sorting('keyword_text', $event)">
						Keywords
						<i
							class="sort fa"
							:class="
							sort.field == 'keyword_text'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i>
					</th>
	                <!-- <th v-if="currentPage == 'sync'">Tags</th> -->
	                <th class="link" v-on:click="sorting('match_type', $event)">Match
						<i
							class="sort fa"
							:class="
							sort.field == 'match_type'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i>
					</th>
					<th style="text-align:right;width:150px"
					class="link" v-on:click="sorting('manually_managed_bid', $event)">
						{{'Manually Managed Bid($)'}}
						<i
							class="sort fa"
							:class="
							sort.field == 'manually_managed_bid'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>
					<th v-if="currentPage == 'sync'" style="text-align:right;width:120px" class="link" v-on:click="sorting('min_bid', $event)">
						{{'Min Bid($)'}}
						<i
							class="sort fa"
							:class="
							sort.field == 'min_bid'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>
					<th v-if="currentPage == 'sync'" style="text-align:right;width:120px" class="link" v-on:click="sorting('max_bid', $event)">
						{{'Max Bid($)'}}
						<i
							class="sort fa"
							:class="
							sort.field == 'max_bid'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>
						<!-- <th style="text-align:right;width:120px">{{'Current Bid($)'}}</th> -->
						<th style="text-align:right;width:120px" class="link" v-on:click="sorting('current_bid', $event)">{{'Current Bid($)'}}
						<i
							class="sort fa"
							:class="
							sort.field == 'current_bid'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>  
	                <th v-if="currentPage == 'sync'" style="width: 7%;" class="link" v-on:click="sorting('state', $event)">Bid Status
						<i
							class="sort fa"
							:class="
							sort.field == 'state'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i>
					</th>
					<th style="width: 8%;" v-if="currentPage == 'sync'" class="link" v-on:click="sorting('strategy', $event)">
						ML Strategy <span v-if="strageyLoading" span class="spinner-border" style="display: block;"></span>
						<i
							class="sort fa"
							:class="
							sort.field == 'strategy'
							? sort.order == 'asc'
								? 'fa-arrow-up'
								: 'fa-arrow-down'
							: ''
							"
						></i></th>
					<th v-if="currentPage == 'sync'" style="text-align:right">Bid Change(%)</th>
					<th></th>
					<th v-if="currentPage == 'sync'"></th>
					<th style="width:5%;"></th>
	                <th v-if="showAllField">Impressions</th>
	                <th v-if="showAllField">Clicks</th>
	                <th v-if="showAllField">CTR</th>
	                <th v-if="showAllField">ACPC</th>
	                <th v-if="showAllField">Spend($)</th>
	                <th v-if="showAllField">Sales</th>
					<th v-if="showAllField">ACOS</th>
	            </tr>
				
	        </thead>
			<!-- sd type -->
			<tbody v-if="($route.params.sponsoredType||'')=='sd'">
				<tr v-for="(item, k) in keywordList" :key="k" :class="k%2==0?'even':''">
					<template>
						<td class="text-center">
							
							<input
								type="checkbox"
								:id="item.asin"
								:value="item.asin"
								v-model="item.checked"
								@change="selected(item)"
							>
						</td>
						<td>
							<i class="fas fa-circle color-green" v-if="item.active"></i>
							<i class="fas fa-circle color-orange" v-if="!item.active"></i>
						</td>
						<td v-if = "item.manually_managed" style = "color:orange">{{ item.asin }}</td>
						<td v-else>{{ item.asin }}</td>
						<td> {{item.product_title}}</td>
						<!-- <td class="key_tags">
							<span
								data-toggle="tooltip"
								@mouseover=tooltipCode()
								:title=getToolTipData(item.tags)
								class="label label-info tag"
								v-if = "item.tags"
							>{{parseTag(item.tags)}}</span>
						</td> -->
						<td>
							<div class="editable right" title="Click to edit" :class="(item.min_bid||item.max_bid)?'blocked':''" @click="(!item.min_bid && !item.max_bid)?openBidPopup($event, item, 'bid', k):''" >
								{{renderBidCondition(item)}}
							</div>
						</td>
						<td>
							<div class="editable right" :class="(item.manually_managed)?'blocked':''" title="Click to edit"  @click="(item.manually_managed)?'':openMinMaxBidPopup($event, item.min_bid, 'min', k, item)">
								{{item.min_bid}}
							</div>
						</td>
						<td>
							<div class="editable right" title="Click to edit" :class="(item.manually_managed)?'blocked':''" @click="(item.manually_managed)?'':openMinMaxBidPopup($event, item.max_bid, 'max', k, item)" >
								{{item.max_bid}}
							</div>
						</td>
						<td>
							<div class="editable right blocked" >
								{{renderCurrentBidCondition(item)}}
							</div>
						</td>
						<td style="width:150px;">
							<div class="text-capitalize">
								{{ item.state == "undefined" ? 'none' : item.state}}
							</div>
						</td>
						<td style="width:120px;">
							<div class="text-capitalize" v-if="item.asin && (item.strategy||item.manually_managed)">
								<span v-if='item.manually_managed'>{{'Manually managed'}}</span>
								<span v-else-if="item.strategy">
									{{modifyStrategyLabel(item['strategy'])}}
								</span>
								</div>
						</td>
						<td v-if="!showAllField && currentPage == 'sync'" style="width:120px;text-align:right">
							<div class="text-capitalize" v-if="item.asin && item.parameter">
								{{item.parameter}}
							</div>
						</td>
						<td style="width:120px;">
							<div class="text-capitalize" v-if="item.asin && (item.strategy||item.manually_managed)">
								<span v-if="item['strategy']" @click="viewMore(item)"><a href="javascript:void(0)">{{' History'}}</a></span>
							</div>
						</td>
						<td width="10%">
							<div>
								<button
									type="button"
									style = "padding: 8px;font-size: 16px; margin-top: 0px !important;"
									class="btn btn-primary"
									v-if = "item.manually_managed"
									@click="changetoggleValue($event, k, item)"
								>{{'Enable ML'}} </button>
							</div>
						</td>
						<td class="row-add-edit" v-if="item.tags && item.tags.length" style="text-align: center;">
							<div class="row-add-edit">
								<a style="padding-left: 11px;" href="javascript:void(0)" class="item-add-edit" data-toggle="dropdown"></a>
							<div
								class="dropdown-menu"
								aria-labelledby="dropdownMenuButton"
								style="left:-58px;padding:0px"
							>
								<a class="grid-item ico-delete" @click="openDeleteTagPopUp(item)">Delete tag</a>
							</div>
							</div>
							
						</td>
						<td v-else></td>
					</template>
	            </tr>
			</tbody>
			<!-- sp/sb type -->
	        <tbody v-else>
	            <tr v-for="(item, k) in keywordList" :key="k" :class="k%2==0?'even':''">
					<template v-if="showAllField && currentIndex == item.id">
						<td
						style="margin:5px;"
						colspan="12"
						>
							<div
								class="spinner-border"
								style="margin:auto;display:block;"
							></div>
						</td>
					</template>
					<template v-else>
						<td v-if="currentPage == 'sync'" class="text-center">
							<input
								type="checkbox"
								:id="item.ams_keyword_id"
								:value="item.ams_keyword_id"
								v-model="item.checked"
								@change="selected(item)"
							>
						</td>
						<td  v-if="currentPage == 'sync'">
							<i class="fas fa-circle color-green" v-if="item.active"></i>
							<i class="fas fa-circle color-orange" v-else></i>
						</td>
						<td v-if = "item.manually_managed" style = "color:orange">{{ item.keyword_text }}</td>
						<td v-else>{{ item.keyword_text }}</td>
						<!-- <td  v-if="currentPage == 'sync'" class="key_tags">
							<span
								data-toggle="tooltip"
								@mouseover=tooltipCode()
								:title=getToolTipData(item.tags)
								class="label label-info tag"
								v-if = "item.tags"
							>{{parseTag(item.tags)}}</span>
						</td> -->
						<td class="text-capitalize">{{ item.match_type }}</td>
						<td v-if="!showAllField && currentPage == 'sync'">
							<div class="editable right" title="Click to edit" :class="(item.min_bid||item.max_bid)?'blocked':''" @click="(!item.min_bid && !item.max_bid)?openBidPopup($event, item, 'bid', k):''" >
								{{renderBidCondition(item)}}
							</div>
						</td>
						<td v-if="!showAllField && currentPage == 'sync'" disabled='true'>
							<div class="editable right" :class="(item.manually_managed)?'blocked':''" title="Click to edit"  @click="(item.manually_managed)?'':openMinMaxBidPopup($event, item.min_bid, 'min', k, item)">
								{{item.min_bid}}
							</div>
						</td>
						<td v-if="!showAllField && currentPage == 'sync'">
							<div class="editable right" title="Click to edit" :class="(item.manually_managed)?'blocked':''" @click="(item.manually_managed)?'':openMinMaxBidPopup($event, item.max_bid, 'max', k, item)" >
								{{item.max_bid}}
							</div>
						</td>
						<td v-if="!showAllField && currentPage == 'sync'">
							<div class="editable right blocked" >
								{{renderCurrentBidCondition(item)}}
							</div>
						</td>
						<td v-if="!showAllField && currentPage != 'sync'" class="text-capitalize">{{ item.bid}}</td>
						<td v-if="showAllField">
							<div class="editable text-capitalize" title="Click to edit" @click="openBidPopup($event, item, 'status', k)">
								{{ item.state == "undefined" ? 'none' : item.state}}
							</div>
						</td>
						<td v-if="!showAllField && currentPage == 'sync'" style="width:120px;">
							<div class="text-capitalize">
								{{ item.state == "undefined" ? 'none' : item.state}}
							</div>
						</td>
						<td v-if="!showAllField && currentPage == 'sync'" style="width:120px;">
							<div class="text-capitalize" v-if="item.ams_keyword_id && (item.strategy||item.manually_managed)">
								<span v-if='item.manually_managed'>{{'Manually managed'}}</span>
								<span v-else-if="item.strategy">
									{{modifyStrategyLabel(item['strategy'])}}
								</span>
								<!-- <span v-else-if='item.strategy'>{{((item['strategy']=='Need_based_Exploration'?'Exploration':item['strategy']))}}</span> -->
									<!-- <a v-if="item['bid_change_reason']" href="javascript:void(0)" @mouseover="openReasonPopup($event,item['bid_change_reason'])">See Reason</a> -->
								</div>
						</td>
						<td v-if="!showAllField && currentPage == 'sync'" style="width:120px;text-align:right">
							<div class="text-capitalize" v-if="item.ams_keyword_id && item.parameter">
								{{item.parameter}}
							</div>
						</td>
						<td>
							
							<div class="text-capitalize" v-if="item.ams_keyword_id && (item.strategy||item.manually_managed)">
								<span v-if="item['strategy']" @click="viewMore(item)"><a href="javascript:void(0)">{{' History'}}</a></span>
							</div>
						</td>
						<td v-if="currentPage == 'sync'" width="10%" >
							<div style="padding-top: 0px;">
								<button
									type="button"
									style = "padding: 8px;font-size: 16px;margin-top: 0px !important;"
									class="btn btn-primary"
									v-if = "item.manually_managed"
									@click="changetoggleValue($event, k, item)"
								>{{'Enable ML'}} </button>
							</div>
						</td>
						<td  v-if="showAllField">{{ item.impressions ? item.impressions : 0 }}</td>
						<td  v-if="showAllField">{{ item.clicks ? item.clicks : 0 }}</td>
						<td  v-if="showAllField">{{ item.ctr ? item.ctr : 0 }}</td>
						<td  v-if="showAllField">{{ item.acpc ? item.acpc : 0}}</td>
						<td  v-if="showAllField">{{ item.cost ? item.cost : 0 }}</td>
						<td  v-if="showAllField">{{ item.sales ? item.sales : 0}}</td>
						<td  v-if="showAllField">{{ item.acos  ? item.acos : 0 }}</td>
						<td class="row-add-edit" v-if="item.tags && item.tags.length" style="text-align: center;">
							<div class="row-add-edit" style="margin-left: 20px;">
								<a href="javascript:void(0)" class="item-add-edit" data-toggle="dropdown"></a>
								<div
									class="dropdown-menu"
									aria-labelledby="dropdownMenuButton"
									style="left:-58px;padding:0px"
								>
									<a class="grid-item ico-delete" @click="openDeleteTagPopUp(item)">Delete tag</a>
								</div>
							</div>
														
						</td>
						<td v-else></td>
					</template>
	            </tr>
	        </tbody>
	    </table>
		<NoDataAvailable displayMessage="No data available " v-else></NoDataAvailable>
		<DeleteTag :keyTagToDel = "keyTagToDel" @closeDelTagPopUp = "closeDelTagPopUp"/>
		<DescriptionPopUp
			ref="keyDescPopUp"
			:title="title"
			:id='amsKeywordId'
			:showSpinner="fetchingDesc"
			:descArray='keywordDescList'
			@fetchKeywordDesc='viewMore'
			@resetPagination='resetKeyDescPagination'
		/>
	</div>
</template>

<script>
import DescriptionPopUp from './CampDetailKeywordDesc'
import NoDataAvailable from '../NoDataAvailable.vue';
import DeleteTag from '@/components/keyword/DeleteTag.vue';
var moment = require("moment");
export default {
    name: 'CampaignDetailGridNew',
    data() {
        return {
			bidSaving:false,
			strategyReason:'',
			showLoader:false,
			showBidPopup:false,
			editType:'bid',
			currentIndex:null,
			selectedItem:{},
			selectedItemIndex:-1,
			keyTagToDel:{},
			tempBidVal:'',
			bidType:'',
			showMinMaxBid:false,
			minMaxBid:'',
			isWrongVal:false,
			isWrongBid:false,
			title:'',
			fetchingDesc:false,
			descArray:[],
			amsKeywordId:null,
			strategy_reason: 'ji reason',
			showStrategy:false
        }
    },
	components : {
	  NoDataAvailable,
	  DeleteTag,
	  DescriptionPopUp
    },
	props: {
		sort:{
			type: Object
		},
		keywordList: {
			type: Array
		},
		showAllField:{
			type:Boolean
		},
		maxBidLimit: {
			type: String
		},
		minBidLimit: {
			type: String
		},
		strageyLoading:{
			type:Boolean
		}
	},
	mounted(){
		this.$store.dispatch("callAnalytics", {data:window.location.href, this:this, type:'keywordList'})
	},
	computed:{
		currentPage(){
			return this.$store.state.keywordCurrentTab
		},
		actionSelectionControl: {
			set(val) {
				this.$store.state.campaign.actionSelectionControl = val
				if (val) {
					this.selectAllKeyword()
				}
				else {
					this.resetSelectAllKeyword()
				}
			},
			get() {
				return this.$store.state.campaign.actionSelectionControl
			}
		},
		keyWordToTagList:{
			set(val) {
				this.$store.state.campaign.keyWordToTagList = val
			},
			get() {
				if(this.$store.state.campaign.keyWordToTagList.length == 0){
					this.resetSelectAllKeyword()
				}
				return this.$store.state.campaign.keyWordToTagList
			}
		},
		keywordDescList:{
			set(val){
				this.$store.state.keywordDescList = val
			},
			get(){
				return this.$store.state.keywordDescList
			}
		},
		showPerPage: {
			set(val) {
				this.$store.state.keywordDescShowPerPage = val;
			},
			get() {
				return this.$store.state.keywordDescShowPerPage;
			},
		},
		currentPageNumber: {
			set(val) {
				this.$store.state.keywordDescCurrentPageNumber = val;
			},
			get() {
				return this.$store.state.keywordDescCurrentPageNumber;
			},
		},
		totalKeywordDescCount: {
			set(val) {
				this.$store.state.totalKeywordDescCount = val;
			},
			get() {
				return this.$store.state.totalKeywordDescCount;
			},
		},
	},
	watch:{
		keyWordToTagList(){},
	},
	methods:{
		sorting(field, event) {
			if (
				event.currentTarget.children[0].classList[2] == "fa-arrow-up" ||
				event.currentTarget.children[0].classList[2] == "fa-arrow-down"
			) {
				var pastEvent = true;
			}
			for (var i = 0; i < document.getElementsByClassName("sort").length; i++) {
				document
				.getElementsByClassName("sort")
				[i].classList.remove("fa-arrow-up");
				document
				.getElementsByClassName("sort")
				[i].classList.remove("fa-arrow-down");
			}
			if (pastEvent) {
				this.sort.order == "desc"
				? event.currentTarget.children[0].classList.add("fa-arrow-up")
				: event.currentTarget.children[0].classList.add("fa-arrow-down");
				pastEvent = false;
			} else {
				event.currentTarget.children[0].classList.add("fa-arrow-up");
			}
			this.$emit('updateSortVariable',{
				field: field,
				order:
				event.currentTarget.children[0].classList[2] == "fa-arrow-up"
					? "asc"
					: "desc",
			});
		},
		renderBidCondition(item){
			if(item.manually_managed){
				return item.bid
			}
			else 
				return ''
		},
		renderCurrentBidCondition(item){
			if (item.manually_managed && item.bid_modified_on && item.currentBidDate && item.bid && item.currentBid){
				 if(moment(moment(item.currentBidDate).utc().format("YYYY-MM-DD")).isAfter(moment(moment(item.bid_modified_on).utc().format("YYYY-MM-DD")))){
					return item.currentBid.toFixed(2)
				 }
				 else{
					 return item.bid
				 }
			}
			else if(item.manually_managed && item.bid_modified_on && moment(item.bid_modified_on).utc().format("YYYY-MM-DD")==moment().utc().format("YYYY-MM-DD")){
				return item.bid
			}
			else{
				if(item.currentBid){
					return item.currentBid.toFixed(2)
				}
				else if(item.ml_bid){
					return item.ml_bid.toFixed(2)
				}
				else 
					return ''
			}
		},
		parseBid(bid){
			bid ? "":(bid = 0) 
			if(bid >=1){
				return `$${bid}`
			}
			else{
				return `${bid * 100}¢`
			}
		},
		fixBidDecimal(event){
			{
				let bidArr = []
				bidArr = this.tempBidVal.toString().split('.')
				if(bidArr && bidArr.length>1 && bidArr[1].length>1 && event.keyCode!=8 && event.keyCode!=46 && (event.keyCode<37 || event.keyCode >40)){
					event.preventDefault()
				}
			}
		},
		fixMinMaxBidDecimal(event){
			{
				let minMaxArr = []
				minMaxArr = this.minMaxBid.toString().split('.')
				if(minMaxArr && minMaxArr.length>1 && minMaxArr[1].length>1 && event.keyCode!=8 && event.keyCode!=46 && (event.keyCode<37 || event.keyCode >40)){
					event.preventDefault()
				}
			}
		},
		getToolTipData(tags){
			let data = tags.split(',');
			data.splice(0,1);
			data = data.join(', ')
			return data
		},
		tooltipCode(){
			$(document).ready(function(){
				$('[data-toggle="tooltip"]').tooltip();
			});
		},
		parseTag(tags){
			let data = tags.split(',');
			return data[0];
		},
		modifyStrategyLabel(itemStrategy){
			switch(itemStrategy){
				case 'Exploitation':
					return 'Optimizing'
				
				case 'Need_based_Exploration':
				return 'Optimizing'
				
				case 'Fixed_increment':
				return 'Exploration'
				
				case 'Manually_managed':
				return 'Manually Managed'
				
				default:
					return itemStrategy;
			}

		},
		resetKeyDescPagination(){
			this.currentPageNumber = 1;
			this.showPerPage = 25
			this.keywordDescList = []
			this.totalKeywordDescCount = 0
		},
		viewMore(item){
			let type = this.$route.params.sponsoredType == 'sd'?'asin':''
			let payload = {
				// 26464129497182
				ams_keyword_id: item.ams_keyword_id,
				target_id:item.target_id,
				pageNumber: this.currentPageNumber,
				resultsPerPage: this.showPerPage
			}
			if(type && type=='asin'){
				payload['type'] = 'sd'
			}
			//we are setting target_id for sd type and amsKeyword id for rest of types
			if(this.$route.params.sponsoredType=='sd'){
				this.amsKeywordId = payload['target_id']
			}
			else{
				this.amsKeywordId = payload['ams_keyword_id']
			}
			this.title = type&&type=='asin'?item.asin:item.keyword_text
			let vm = this;
			vm.$refs["keyDescPopUp"].openPopUp();
			vm.fetchingDesc = true
			this.$store.dispatch("campaign/getKeywordDescDetails", payload).then((resp) => {
				this.fetchingDesc = false
			})

		},
		updateBid(e){
			if((parseFloat(e.target.value) > parseFloat(this.maxBidLimit))||(parseFloat(e.target.value) < parseFloat(this.minBidLimit))){
					this.isWrongBid = true
				}
				else{
					this.isWrongBid = false
				}
		},
		updateMinMaxBid(e){
			if(this.bidType == 'max'){
				let minVal = this.keywordList[this.selectedItemIndex].min_bid
				if(minVal){
					if(parseFloat(e.target.value) < parseFloat(minVal)){
						this.isWrongVal = true
						return;
					}
					else{
						this.isWrongVal = false
					}
				}
				if((parseFloat(e.target.value) > parseFloat(this.maxBidLimit))||(parseFloat(e.target.value) < parseFloat(this.minBidLimit))){
					this.isWrongVal = true
				}
				else{
					this.isWrongVal = false
				}
			}
			else if (this.bidType == 'min'){
				let maxVal = this.keywordList[this.selectedItemIndex].max_bid;
				if(maxVal){
					if(parseFloat(e.target.value) > parseFloat(maxVal)){
						this.isWrongVal = true
						return;
					}
					
					else{
						this.isWrongVal = false
					}
				}
				if((parseFloat(e.target.value) > parseFloat(this.maxBidLimit))||(parseFloat(e.target.value) < parseFloat(this.minBidLimit))){
					this.isWrongVal = true
				}
				else{
					this.isWrongVal = false
				}
			}
		},
		updateKeywordRow(e, item, index, tempBidVal){
			//if user haven't updated the value, neither update manually manage nor make call at backend 
			if((!tempBidVal && !this.keywordList[index].bid) || (parseFloat(tempBidVal) == parseFloat(this.keywordList[index].bid))){
				this.showBidPopup = false;
				return
			}
			let type = this.$route.params.sponsoredType
			e.stopPropagation();
			let vm = this;
			this.showLoader = true;
			this.currentIndex = item.id;
			let payload = {
				id:item.id,
				bid: tempBidVal,
				campaign_id : this.$route.params.campaignId,
				type: type,
				ams_keyword_id: item.ams_keyword_id,
				target_id: type && type=='sd'?item.target_id:null,
				ams_campaign_id: item.ams_campaign_id
			}
			this.bidSaving = true
			this.$store.dispatch("campaign/editKeywordBid", payload).then((resp)=>{
				console.log('done', resp);
				this.showBidPopup = false;
				vm.$emit('updateKeywordData',{index:index,bid_temp_value:tempBidVal,type:'cpcBid',date:moment().utc()})
				vm.keywordList[index].manually_managed = (tempBidVal==''||tempBidVal==null)?false:true;
				vm.keywordList[index].bid_temp_value = tempBidVal;
			//	vm.updateList();
				vm.showLoader = false;
				vm.currentIndex = null;
				vm.bidSaving = false
			})
		},
		updateList(){
			this.$emit("showPerPageChanged")
		},
		selected(item){
			let data = this.$store.state.campaign.keyWordToTagList;

			if (item.checked) {
				data.push(item);
			} else {
				let index = data.indexOf(item);
				if (index > -1) {
					data.splice(index, 1);
				}
			}
			this.$store.state.campaign.actionSelectionControl = false
		},
		resetSelectAllKeyword(){
			let data = JSON.parse(JSON.stringify(this.keywordList));
			data = data.map((res) => {
				res.checked = false
				return res
			})
			this.keywordList = JSON.parse(JSON.stringify(data))
			this.keyWordToTagList = []
		},
		selectAllKeyword(){
 			this.keywordList.map((res) => {
				res.checked = true
				this.keyWordToTagList.push(res);
				return res
			})
		},
		openBidPopup(event, item, editType, index){
			this.showMinMaxBid = false
			this.showBidPopup = true;
			this.selectedItem = JSON.parse(JSON.stringify( item));
			//this.tempBidVal = (item.bid_temp_value ? item.bid_temp_value : item.bid)
			this.tempBidVal = '';
			this.selectedItemIndex = index;
			this.editType = editType;
			this.$nextTick(() => {
				document.getElementById('bid-popup').style.top = event.y + window.scrollY + 'px';
				document.getElementById('bid-popup').style.left = (event.x - (317/2))+ 'px';
				this.$refs['id__bid'].focus()
			});
			//console.log('event', event.x, event.y, event);
		},
		openMinMaxBidPopup(event, value, type, index, item){
			this.selectedItem = JSON.parse(JSON.stringify( item));
			this.showBidPopup = false
			this.showMinMaxBid = true;
			this.selectedItemIndex = index;
			this.minMaxBid = value
			if(type == 'max'){
				this.bidType = 'max'
			}
			if(type == 'min'){
				this.bidType = 'min'
			}
			this.$nextTick(() => {
				document.getElementById('bid-popup2').style.top = event.y + window.scrollY + 'px';
				document.getElementById('bid-popup2').style.left = (event.x - (317/2))+ 'px';
				this.$refs["id__max__min"].focus()
			});
		},
		openReasonPopup(event,reason){
			this.strategyReason = reason
			this.showStrategy = true;
			this.$nextTick(() => {
				document.getElementById('strategy-reason').style.top = event.y + window.scrollY + 'px';
				document.getElementById('strategy-reason').style.left = (event.x - (317/2))+ 'px';
			});
		},
		updateBidVal(e, item, index){
			let compareBid = this.bidType == 'max' ? 'max_bid' : 'min_bid'
			//if user haven't updated the value, neither update bid nor make call at backend 
			if((!this.minMaxBid && !this.keywordList[index][compareBid]) || (parseFloat(this.minMaxBid) == parseFloat(this.keywordList[index][compareBid]))){
				this.showMinMaxBid = false;
				return
			}
			e.stopPropagation();
			let payload = {
				id:item.id,
				ams_keyword_id:item.ams_keyword_id,
				sponsoredType:this.$route.params.sponsoredType,
				target_id: this.$route.params.sponsoredType && this.$route.params.sponsoredType=='sd'?item.target_id:null
			}
			if(this.bidType == 'max'){
				payload.bid = (this.minMaxBid||this.minMaxBid==0)?this.minMaxBid:null
				payload.type = 'max'
			}
			else{
				payload.bid = (this.minMaxBid==0||this.minMaxBid)?this.minMaxBid:null
				payload.type = 'min'
			}
			this.bidSaving = true
			let vm = this;
			this.showLoader = true;
			this.$store.dispatch("campaign/minMaxBidUpdate", payload).then((resp)=>{
				if(resp){
					// if(vm.bidType == 'max'){
					// 	vm.keywordList[index].max_bid = vm.minMaxBid;
					// }
					// else{
					// 	vm.keywordList[index].min_bid = vm.minMaxBid;
					// }
					let id =JSON.parse(JSON.stringify(vm.keywordList[index]['id'] || "")); 
					let strategy = vm.keywordList[index]['strategy'];
					let parameter = vm.keywordList[index]['parameter'];
					let tags = vm.keywordList[index]['tags']
					let bid = vm.keywordList[index]['ml_bid']
					let title = vm.keywordList[index]['product_title']
					let asin = vm.keywordList[index]['asin']
					let currentBid = vm.keywordList[index]['currentBid']
					//let asin = vm.keywordList[index]['asin']
					// let bid_temp = vm.keywordList[index]['bid_temp_value'] ||vm.keywordList[index]['bid'] ||null;
					resp['strategy'] = strategy
					resp['parameter'] = parameter
					resp['tags'] = tags
					resp['bid'] = bid
					resp['ml_bid'] = bid
					resp['id'] = id;
					resp['asin'] = asin
					resp['product_title'] = title
					resp['currentBid'] = currentBid
					// resp['bid_temp_value'] = bid_temp
					// resp['bid'] = bid_temp
					vm.$emit('updateKeywordData',{index:index,keyRow:resp,type:'minMaxBid'})
					// vm.keywordList[index] = resp
					// vm.keywordList[index]['bid_temp_value']  = bid_temp;
					// vm.keywordList[index]['bid']  = bid_temp;
					// vm.keywordList[index]['strategy'] = strategy;
					// vm.keywordList[index]['parameter'] = parameter;
					vm.showMinMaxBid = false
					vm.minMaxBid = '';
					vm.bidType = ''
					vm.showLoader = false;
					vm.currentIndex = null;
					vm.bidSaving = false
				}
			})

		},
		changetoggleValue($e, index, item){
			let type = this.$route.params.sponsoredType
			let payload = {
				id:item.id,
				type:type,
				ams_keyword_id:item.ams_keyword_id,
				target_id: type && type=='sd'?item.target_id:null
			}
			let vm = this;
			this.$store.dispatch("campaign/switchOffKeyword", payload).then((res) => {
				if(res && res.status=='Success'){
					// // let bid = item.ml_bid
					// this.$emit('updateKeywordData',{index:index,bid:bid, type:'enableMl'})
					this.showBidPopup = false
					this.$emit('updateKeywordData',{index:index, type:'enableMl',bid:res.bid})
				}
			})
		},
		parseTagsData(data){
			if(data){
				let arr = data.split(',');
				arr = arr.sort();
				return arr.join(', ')
			}
			else{
				return ''
			}

		},
		openDeleteTagPopUp(data){
			this.showMinMaxBid = false
			this.showBidPopup = false;
			this.keyTagToDel = data
			$("#deleteTagForKeyword").modal('show')
		},
		closeDelTagPopUp(){
			this.keyTagToDel = {};
			$("#deleteTagForKeyword").modal('hide')
			this.$emit("showPerPageChanged")
		}
	}
}
</script>

<style scoped src="@/assets/css/main.css"></style>
<style lang="scss">
    .custom-table-row-td {
        padding: 0 10px !important;
    }
	.editable{
		cursor: pointer;
		border: 1px solid #CED4DA;
		padding: 5px;
		border-radius: 3px;
		min-height:30px;
		&.right{
			text-align: right !important;
			height: 36px;
		}
	}
	.blocked{
		background-color: #e9ecef !important;
	}
	.form-control.bid-status:disabled{
		background-color: #0000;
		cursor: pointer;
	}
	// #bid-popup{
	// 	width: 317px;
	// 	position: absolute;
	// 	padding: 10px;
	// 	background: #fff;
	// 	border-radius: 5px;
	// 	border: 2px solid #eee;
	// 	height: 80px;
	// 	z-index: 1;
	// }
	// #bid-popup {
	// 	.budget-value{
	// 		padding: 9px;
	// 		font-weight: 500;
	// 		width: 100px;
	// 	}
	// }
	// #bid-popup {
	// 	.btn.btn-primary{
	// 		padding: 6px 15px;
	// 	}
	// }
	// #bid-popup {
	// 	.bid-status{
	// 		width: 110px;
	// 		float: left;
	// 		height: 38px;
	// 		margin-top: 8px;
	// 	}
	// }
	// #bid-popup .info{
	// 	font-size:12px;padding:4px;border:1px solid black;margin-bottom:auto
	// }



	#bid-popup{
		width: 317px;
		position: absolute;
		padding: 10px;
		background: #fff;
		border-radius: 5px;
		border: 2px solid #eee;
		height: 125px;
		z-index: 1;
	}
	#bid-popup .budget-value{
		padding: 9px;
		font-weight: 500;
		width: 100px;
		
	}
	#bid-popup .btn.btn-primary{
		padding: 6px 15px;
	}
	#bid-popup .bid-status{
		width: 110px;
		float: left;
		height: 38px;
		margin-top: 8px;
	}
	#bid-popup .info{
		font-size:12px;padding:4px;border:1px solid black;margin-bottom:auto
	}

	#bid-popup2{
		width: 317px;
		position: absolute;
		padding: 10px;
		background: #fff;
		border-radius: 5px;
		border: 2px solid #eee;
		height: 125px;
		z-index: 1;
	}
	#bid-popup2 .budget-value{
		padding: 9px;
		font-weight: 500;
		width: 100px;
	}
	#bid-popup2 .btn.btn-primary{
		padding: 6px 15px;
	}
	#bid-popup2 .bid-status{
		width: 110px;
		float: left;
		height: 38px;
		margin-top: 8px;
	}
	#bid-popup2 .info{
		font-size:12px;padding:4px;border:1px solid black;margin-bottom:auto
	}
	
	.reason_popover{
		border: 1px solid black;
		height: 280px;
		max-width: 450px;
		position: absolute;
		background-color: white;
		padding:10px;
		word-wrap:break-word;
	}
	.text-capitalize{
		    text-transform: capitalize;
	}
	.key_tags{
		.tag{
			padding-bottom: 5px;
    		padding-top: 5px;
			cursor:pointer
		}
	}


</style>
